/**
 * NewListingPage Component
 *
 * Page for creating a new listing.
 */

import React from 'react';
import { Navigate, Link } from 'react-router-dom';
import { Footer } from '../../../components/layout/Footer/Footer';
import { ListingWizard } from './components';
import { useAuth } from '../../../contexts';

export const NewListingPage: React.FC = () => {
  const { user, isLoading } = useAuth();

  // Check if user is a host
  if (!isLoading && user && user.role !== 'host' && user.role !== 'admin') {
    return <Navigate to="/become-host" replace />;
  }

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      {/* Simplified header for wizard mode */}
      <div className="bg-white border-b border-gray-200 sticky top-0 z-40">
        <div className="max-w-5xl mx-auto px-4 py-4">
          <Link to="/host" className="flex items-center">
            <img src="/logos/logo-wide.png" alt="DARAK" className="h-8 w-auto object-contain" />
          </Link>
        </div>
      </div>

      {/* Wizard Content */}
      <div className="flex-1 max-w-5xl mx-auto px-4 py-8 w-full">
        <ListingWizard mode="create" />
      </div>

      <Footer />
    </div>
  );
};

export default NewListingPage;
